module.exports = "//static.hsappstatic.net/marketplace-unified-public-base/static-1.1029/img/provider-ctas-blob-2x.png"